import React, { useEffect, useState } from 'react';
import { Card, Text, Button, Collapsible, BlockStack, InlineStack, InlineGrid, RadioButton, Box } from '@shopify/polaris';
import { ChevronDownIcon, ChevronUpIcon } from '@shopify/polaris-icons';
import Language from '../../../../../i18n/Language';
const t = Language;

// Advanced settings（Meta robots index / follow）
// 视觉对齐 Figma：单卡片、可折叠、两列单选；保留底部 Save 按钮（原逻辑：切换后可保存）
// 保存交由父级 onSave 处理（统一走 reqSaveContentAudit，action=IndexAndFollow）
const AdvancedSettings = (props) => {
    const { level, initData = {}, show, toggleToast, onSave } = props;

    const [open, setOpen] = useState(true);
    const [noindex, setNoindex] = useState('0');
    const [nofollow, setNofollow] = useState('0');
    const [saving, setSaving] = useState(false);
    const [disabled, setDisabled] = useState(true);

    // initData 由父级页面数据异步填充，保持同步
    // 注意：initData 每次渲染都是新对象，这里取原始标量值做依赖，避免父级重渲染把本地选择重置
    const _initNoindex = Array.isArray(initData.noindex) ? initData.noindex[0] : initData.noindex;
    const _initNofollow = Array.isArray(initData.nofollow) ? initData.nofollow[0] : initData.nofollow;
    const initNoindexStr = _initNoindex != null ? String(_initNoindex) : '0';
    const initNofollowStr = _initNofollow != null ? String(_initNofollow) : '0';
    useEffect(() => {
        setNoindex(initNoindexStr);
        setNofollow(initNofollowStr);
        setDisabled(true);
    }, [initNoindexStr, initNofollowStr]);

    const handleChange = (name, value) => {
        if (name === 'noindex') {
            setNoindex(value);
        } else {
            setNofollow(value);
        }
        setDisabled(false);
    };

    const handleSave = async () => {
        // 免费用户拦截，弹升级弹窗，不落库
        if (level === 1) {
            show && show();
            return;
        }
        if (typeof onSave !== 'function') return;
        setSaving(true);
        try {
            const response = await onSave({ noindex, nofollow });
            if (response.code === '200') {
                toggleToast && toggleToast(response.msg, false);
                setDisabled(true);
            } else if (response.code === '1000') {
                show && show();
            } else {
                toggleToast && toggleToast(response.msg, true);
            }
        } catch (e) {
            toggleToast && toggleToast(t("Save failed"), true);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Card>
            <BlockStack gap="300">
                <InlineStack align="space-between" blockAlign="center">
                    <Text variant="headingSm" as="h3">{t("Advanced settings")}</Text>
                    <Button
                        variant="tertiary"
                        icon={open ? ChevronUpIcon : ChevronDownIcon}
                        onClick={() => setOpen((v) => !v)}
                        accessibilityLabel={t("Advanced settings")}
                    />
                </InlineStack>
                <Collapsible
                    id="audit_advanced_settings_collapsible"
                    open={open}
                    transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                    expandOnPrint
                >
                    <Box borderColor="border" borderBlockStartWidth="025" paddingBlockStart="300">
                        <BlockStack gap="200">
                            <InlineGrid columns={{ xs: 1, sm: 2 }} gap="300">
                                <BlockStack gap="300">
                                    <BlockStack gap="100">
                                        <Text variant="bodyMd" fontWeight="medium" as="p">{t("Meta robots index")}</Text>
                                        <Text variant="bodySm" tone="subdued" as="p">{t("Decide if you want search engine to find this page.")}</Text>
                                    </BlockStack>
                                    <BlockStack gap="200">
                                        <RadioButton label={t("Index")} checked={noindex === '0'} id="advanced_index_0" name="advanced_noindex" onChange={() => handleChange('noindex', '0')} />
                                        <RadioButton label={t("No index")} checked={noindex === '1'} id="advanced_index_1" name="advanced_noindex" onChange={() => handleChange('noindex', '1')} />
                                    </BlockStack>
                                </BlockStack>
                                <BlockStack gap="300">
                                    <BlockStack gap="100">
                                        <Text variant="bodyMd" fontWeight="medium" as="p">{t("Meta robots follow")}</Text>
                                        <Text variant="bodySm" tone="subdued" as="p">{t("Decide if you want search engine to follow the links on this page.")}</Text>
                                    </BlockStack>
                                    <BlockStack gap="200">
                                        <RadioButton label={t("Follow")} checked={nofollow === '0'} id="advanced_follow_0" name="advanced_nofollow" onChange={() => handleChange('nofollow', '0')} />
                                        <RadioButton label={t("No Follow")} checked={nofollow === '1'} id="advanced_follow_1" name="advanced_nofollow" onChange={() => handleChange('nofollow', '1')} />
                                    </BlockStack>
                                </BlockStack>
                            </InlineGrid>
                            <InlineStack align="end">
                                <Button variant="primary" disabled={disabled} loading={saving} onClick={handleSave}>{t("Save")}</Button>
                            </InlineStack>
                        </BlockStack>
                    </Box>
                </Collapsible>
            </BlockStack>
        </Card>
    );
};

export default AdvancedSettings;
